// extracted by mini-css-extract-plugin
export default {"wrapper":"FeaturesSettings_wrapper__l9w32","centerX":"FeaturesSettings_centerX__zVEnW","horizontalSeparator":"FeaturesSettings_horizontalSeparator__-A1oS"};